<div  class="border rounded-xl border-solid border border-[#53565B38] bg-[#fff] shadow-none mb-3 h-auto  ">
  <div class="flex flex-row px-6 pt-6" >
    @for (basicItem of setupList; track basicItem; let i = $index) {
      <div class="h-1.5 w-14 rounded-[40px] mr-1"  [ngClass]="{'bg-[#25508E]': i == currentStep  , 'bg-[#7E9BD4]' : i < currentStep ,'bg-[#DCDCDC]' : i > currentStep  }" >
      </div>
    }
  </div>
  @for (basicItem of setupList; track basicItem; let i = $index) {
    @if (i == currentStep) {
      <p  style="text-transform: capitalize;" class=" px-6 pt-2 sm:mb-0 text-base text-[#53565B] font-bold">
        {{basicItem.label}}
      </p>
    }
  }
  <div class="flex flex-row px-6 pt-6" >
    @for (basicItem of setupList; track basicItem; let i = $index) {
      @if (i == currentStep) {
        @if (basicItem.type == 'name') {
          <onboarding-form-name-widget
            style="width: 100%;"
            [form_name]="form_name"
            #OnboardingFormNameWidget
            [data]="data"
            [currentuserId]="currentuserId"
            >
          </onboarding-form-name-widget>
        }
        @if (basicItem.type == 'general') {
          <div class="my-[10px]">
            <form [formGroup]="documentForm" class="document-container">
              <div
                formArrayName="dynamicFieldsForm"
                class="flex flex-row flex-wrap justify-between"
                >
                @for (arrayItem of arrayItems; track arrayItem; let i = $index) {
                  <div
                    [formGroupName]="'0'"
                    [ngStyle]="{ width: arrayItem?.width ? (arrayItem?.width == '99%' ? '100%' : arrayItem?.width) : '100%' }"
                    class="dynamic-form-field-container"
                    >
                    @if (arrayItem?.type == 'Section' && arrayItem.label != 'General Information') {
                      <label
                        style="color: #25508e"
                        class="array-item-title section-lable"
                        >{{ arrayItem.label }}
                        @if (arrayItem?.label) {
                          <span
                            matTooltip="Fields displayed are based on the selected template."
                            class="material-icons info-icon-custom"
                            >info</span
                            >
                          }
                        </label>
                      }
                      @if (arrayItem?.type == 'email') {
                        <div style="width: 100% !important">
                          <mat-form-field
                            appearance="fill"
                            [ngClass]="'add-automtic-form-desing'"
                            style="width: 100% !important"
                            class="automtic-form-desing-form-only"
                            >
                            @if (arrayItem?.label) {
                              <mat-label class="automtic-form-desing-lable">
                                {{ arrayItem.label }}
                                @if (arrayItem?.isRequired) {
                                  <span class="automtic-form-desing-required-sign"> * </span>
                                }
                              </mat-label>
                            }
                            <input
                              matInput
                              [placeholder]="arrayItem?.placeholder"
                              type="email"
                              [formControlName]="arrayItem?.formControlName"
                              />
                            </mat-form-field>
                          </div>
                        }
                        @if (arrayItem?.type == 'text') {
                          <div style="width: 100% !important">
                            @if (arrayItem?.label) {
                              <mat-form-field
                                appearance="fill"
                                [floatLabel]="'auto'"
                                [ngClass]="'add-automtic-form-desing'"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                                >
                                <mat-label class="automtic-form-desing-lable">
                                  {{ arrayItem.label }}
                                  @if (arrayItem?.isRequired) {
                                    <span class="automtic-form-desing-required-sign"> * </span>
                                  }
                                </mat-label>
                                @if (arrayItem?.makeEyeField) {
                                  <input
                                    matInput
                                    [placeholder]="arrayItem?.placeholder"
                                    [type]="arrayItem.setDefaultEyeField ? 'password' : 'text'"
                                    [formControlName]="arrayItem?.formControlName"
                                    />
                                }
                                @if (!arrayItem?.makeEyeField) {
                                  <input
                                    matInput
                                    [placeholder]="arrayItem?.placeholder"
                                    [formControlName]="arrayItem?.formControlName"
                                    />
                                }
                                @if (arrayItem?.makeEyeField) {
                                  <button
                                    mat-icon-button
                                    matSuffix
                                    (click)="clickNt(i)"
                                    [attr.aria-label]="'Hide password'"
                                    >
                                    <mat-icon>{{ arrayItem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                                  </button>
                                }
                              </mat-form-field>
                            }
                          </div>
                        }
                        @if (arrayItem?.type == 'number') {
                          <div style="width: 100% !important">
                            <mat-form-field
                              appearance="fill"
                              [floatLabel]="'auto'"
                              [ngClass]="'add-automtic-form-desing'"
                              style="width: 100% !important"
                              class="automtic-form-desing-form-only"
                              >
                              @if (arrayItem?.label) {
                                <mat-label class="automtic-form-desing-lable">
                                  {{ arrayItem.label }}
                                  @if (arrayItem?.isRequired) {
                                    <span class="automtic-form-desing-required-sign"> * </span>
                                  }
                                </mat-label>
                              }
                              <input
                                matInput
                                id="target"
                                [placeholder]="arrayItem?.placeholder"
                                pattern="\d+"
                                type="text"
                                [formControlName]="arrayItem?.formControlName"
                                />
                              </mat-form-field>
                            </div>
                          }
                          @if (arrayItem?.type == 'date') {
                            <div style="width: 100% !important">
                              <mat-form-field
                                appearance="fill"
                                [floatLabel]="'auto'"
                                [ngClass]="'add-automtic-form-desing'"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                                >
                                @if (arrayItem?.label) {
                                  <mat-label class="automtic-form-desing-lable">
                                    {{ arrayItem.label }}
                                    @if (arrayItem?.isRequired) {
                                      <span class="automtic-form-desing-required-sign"> * </span>
                                    }
                                  </mat-label>
                                }
                                <input
                                  matInput
                                  [matDatepicker]="dp3"
                                  (dateChange)="arrayItem.triggerType "
                                  (click)="dp3.open()"
                                  [formControlName]="arrayItem?.formControlName"
                                  />
                                  <mat-datepicker-toggle  matSuffix [for]="dp3"></mat-datepicker-toggle>
                                  <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                </mat-form-field>
                              </div>
                            }
                            @if (arrayItem?.type == 'select') {
                              <div style="width: 100% !important">
                                <mat-form-field
                                  appearance="fill"
                                  [floatLabel]="'auto'"
                                  [ngClass]="'add-automtic-form-desing'"
                                  style="width: 100% !important"
                                  class="automtic-form-desing-form-only"
                                  >
                                  <mat-label class="automtic-form-desing-lable">
                                    {{ arrayItem.label }}
                                    @if (arrayItem?.isRequired) {
                                      <span class="automtic-form-desing-required-sign"> * </span>
                                    }
                                  </mat-label>
                                  <mat-select
                                    matNativeControl
                                    disableOptionCentering
                                    [placeholder]="arrayItem?.placeholder"
                                    [formControlName]="arrayItem?.formControlName"
                                    >
                                    @for (item of arrayItem?.options; track item) {
                                      <mat-option [value]="item?.value">
                                        {{ item?.label }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            }
                            @if (arrayItem?.type == 'largeText') {
                              <div style="width: 100% !important">
                                <!-- <ngx-editor-field
                                [mode]="'add'"
                                (bookTitleCreated)="onBookAdded($event)"
                                [arrayItem]="arrayItem"p
                                [formControlValue]="documentForm.controls.dynamicFieldsForm.controls[0].controls[arrayItem?.formControlName].value"
                                >
                              </ngx-editor-field> -->
                            </div>
                          }
                          @if (arrayItem?.type == 'checkBox') {
                            <div style="height: 45.93px !important; padding-top: 10px">
                              <mat-checkbox class="automatic-form-checkbox" [ngClass]="'add-automtic-form-desing'" [formControlName]="arrayItem?.formControlName">
                                <mat-label class="automtic-form-desing-lable">
                                  {{ arrayItem.label }}
                                  @if (arrayItem?.isRequired) {
                                    <span class="automtic-form-desing-required-sign"> * </span>
                                  }
                                </mat-label>
                              </mat-checkbox>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </form>
                </div>
              }
              <!-- <ng-container *ngIf="basicItem.type == 'insurance'">
              <onboarding-form-insurance-widget
                [insurance_attributes]="insurance_attributes"
                [data]="data"
                [currentuserId]="currentuserId"
                >
              </onboarding-form-insurance-widget>
            </ng-container> -->
            @if (basicItem.type == 'notes') {
              <div class="my-[10px] " style="width: 100%;">
                <onboarding-form-notes-widget
                  [data]="data"
                  [index]="i"
                  (passFieldDataEvent)="bindAnswer($event)"
                  >
                </onboarding-form-notes-widget>
              </div>
            }
          }
        }

      </div>
      <div
        class=" bg-[#EBF0FA]  rounded-b-xl flex items-start justify-between px-6 h-12"
        >

        <div  style="min-width: 150px;">
          @if (!(currentStep == 0)) {
            <button
              style="margin-top: 11px !important;border: 1px;"
              (click)="previousReminder()"
              class="h-5 w-auto h-7 px-6 mb-0 leading-[0rem]  bg-transparent text-sm font-semibold text-[#25508e]  rounded-md border-solid border-[#25508e]" >
              <span class="material-icons text-base ml-[4px] leading-[0rem]" style="position: relative;top: 2px;" > arrow_back</span> Previous
            </button>
          }
        </div>
        @if (!(currentStep == (setupList.length -1))) {
          <button
            style="margin-top: 11px !important;"
            class="app__btn--primary h-5 w-auto  px-6 mb-0 leading-[0rem]"
            type="submit"
            (click)="nextReminder()"
            >Next
            <span class="material-icons text-base ml-[4px] leading-[0rem]"> arrow_right_alt</span>
          </button>
        }
      </div>
    </div>